// Cache hodnocení obchodu — 24h v localStorage
function getHodnoceniObchoduData() {
    const CACHE_KEY = "hodnoceni_obchodu_data";
    const TIMESTAMP_KEY = "hodnoceni_obchodu_timestamp";
    const CACHE_DURATION = 24 * 60 * 60 * 1000;

    const cachedTimestamp = localStorage.getItem(TIMESTAMP_KEY);
    const now = Date.now();

    if (cachedTimestamp && (now - parseInt(cachedTimestamp)) <= CACHE_DURATION) {
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
            return Promise.resolve(JSON.parse(cachedData));
        }
    }

    return $.get("/cache/hodnoceni-obchodu/")
        .then(function (data) {
            const $response = $($.parseHTML(data));
            const votesWrapHtml = $response.find(".votes-wrap").html() || "";
            localStorage.setItem(CACHE_KEY, JSON.stringify(votesWrapHtml));
            localStorage.setItem(TIMESTAMP_KEY, now.toString());
            return votesWrapHtml;
        })
        .catch(function () {
            const cachedData = localStorage.getItem(CACHE_KEY);
            return cachedData ? JSON.parse(cachedData) : "";
        });
}

function createReviewsSlider() {
    if ($(".myreviews").length) return;

    getHodnoceniObchoduData().then(function (votesWrapHtml) {
        if (!votesWrapHtml) return;

        const $votesWrap = $("<div>").html(votesWrapHtml);
        const $voteWraps = $votesWrap.find(".vote-wrap");
        if (!$voteWraps.length) return;

        const reviews = [];
        $voteWraps.each(function () {
            const $v = $(this);
            const date = $v.find(".vote-time").text().trim();
            const content = $v.find(".vote-content").text().trim();
            const name = $v.find(".vote-name span").text().trim();
            const stars = $v.find(".star-on").length;

            // Pouze 5* a obsah nad 150 znaků
            if (date && content && name && content.length > 150 && stars === 5) {
                reviews.push({ date, content, name, stars });
            }
        });

        const latest = reviews.slice(0, 8);
        if (!latest.length) return;

        let starsHtml = "";
        for (let i = 0; i < 5; i++) {
            starsHtml += "<span class='star star-on'></span>";
        }

        let slidesHtml = "";
        latest.forEach(function (r) {
            slidesHtml +=
                "<div class='swiper-slide myreview'>" +
                "<div class='myreview-stars'><span class='stars'>" + starsHtml + "</span></div>" +
                "<div class='myreview-text'>" + r.content + "</div>" +
                "<div class='myreview-meta'>" +
                "<span class='myreview-name'>" + r.name + "</span>" +
                "<span class='myreview-delim'>|</span>" +
                "<span class='myreview-date'>" + r.date + "</span>" +
                "</div>" +
                "</div>";
        });

        const html =
            "<div class='myreviews container'>" +
            "<h2 class='myreviews-title'>" + shopDataLayer.references.title + "</h2>" +
            "<div class='whole-wrap myreviews-wrap'>" +
            "<div class='swiper myreviews-slider'>" +
            "<div class='swiper-wrapper'>" + slidesHtml + "</div>" +
            "</div>" +
            "<div class='myswiper-navi navi-myreviews'>" +
            "<div class='swiper-button-prev myswiper-prev'></div>" +
            "<div class='swiper-button-next myswiper-next'></div>" +
            "</div>" +
            "</div>" +
            "<div class='myreviews-buttons'>" +
            "<a href='" + shopDataLayer.references.link + "' class='btn btn-secondary'>" + shopDataLayer.references.textAll + "</a>" +
            "<a href='" + shopDataLayer.references.link + "' class='just-link'>" + shopDataLayer.references.textWrite + "</a>" +
            "</div>" +
            "</div>";

        $(html).insertBefore($(".homepage-blog-wrapper").first());

        new Swiper(".myreviews-slider", {
            spaceBetween: 0,
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: ".navi-myreviews .myswiper-next",
                prevEl: ".navi-myreviews .myswiper-prev",
            },
        });
    });
}

$(document).ready(function () {
    if ($(".in-index").length > 0 && $(".homepage-blog-wrapper").length > 0) {
        try {
            createReviewsSlider();
        } catch (e) {
            console.error("createReviewsSlider error:", e);
        }
    }
});
